import { DeliveryInfo, Dimensions, TMergeTag } from '../../contexts/DesignTool/types';
import { CardFormat } from '../../utils/cardFormat';
import { CardEvent } from '../../utils/invitation';

export interface CardData {
	_id: string;
	owner: string;
	stage: Dimensions;
	designUrl: string;
	deliveryDate: number;
	deliveryInfo: DeliveryInfo;
	isCopyrightDesign: boolean;
	status: string;
	workspace_id: string;
	hostName: string;
	error?: string;
	format?: CardFormat;
	event?: CardEvent;
	createdAt?: string;
	updatedAt?: string;
	mergeTags?: Array<TMergeTag>;
	prospectList_id?: string;
	cardPages: any[];
  title?:string;
	isVideoCard?: boolean;
	videoCardSettings?: {
		deadline?: string;
		maxDuration?: number;
		inviteMessage?: string;
		scheduledSendAt?: string;
		recipientEmail?: string;
		recipientName?: string;
		autoRenderAndSend?: boolean;
		deliveryMode?: 'board' | 'video';
	};
	music?: {
		url: string;
		name: string;
		source: 'upload' | 'library';
	};
	boardSettings?: BoardSettings;
}

export interface BoardSettings {
	occasion?: string;
	recipientFirstName?: string;
	recipientLastName?: string;
	backgroundUrl?: string;
	backgroundColor?: string;
	headerColor?: string;
	titleFont?: string;
	bodyFont?: string;
	introAnimation?: boolean;
	effect?: 'none' | 'confetti' | 'balloons' | 'hearts' | 'fireworks' | 'snowflakes' | 'sparkles' | 'emojis';
	showContributorNames?: boolean;
}

export enum STATUS {
  SENT = 'SENT',
  SCHEDULED = 'SCHEDULED',
  DRAFT = 'DRAFT',
  WORKFLOW = 'WORKFLOW'
}